import { JsonObject } from 'json2typescript';
import { CodeTextDiscriminatorModel } from 'humanresources-common-shared';

@JsonObject('KovanHrPerEmployeeSubtypeTextModel')
export class PerEmployeeSubtypeTextModel extends CodeTextDiscriminatorModel {}
